import {Component, inject, OnInit} from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {Location} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {ProductsService} from '@services/products/products.service';
import {Product, ProductCategory} from '@interfaces/product';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatOption, MatSelect, MatSelectModule} from '@angular/material/select';
import {MatInput} from '@angular/material/input';
import {MatChipsModule} from '@angular/material/chips';
import {FileUploadComponent} from '@pages/products/add-new-product/file-upload/file-upload.component';

@Component({
  selector: 'app-add-new-product',
  imports: [
    MatIcon,
    ReactiveFormsModule,
    MatButton,
    MatFormFieldModule,
    MatChipsModule,
    MatSelect,
    MatOption,
    MatInput,
    MatSelectModule,
    FileUploadComponent,


  ],
  templateUrl: './add-new-product.component.html',
  standalone: true,
  styleUrl: './add-new-product.component.scss'
})
export class AddNewProductComponent implements OnInit {

  private fb = inject(FormBuilder);
  private productsService = inject(ProductsService);
  private _snackBar = inject(MatSnackBar);

  categories?: ProductCategory[];

  applicationTimes = [
    'MORNING', 'EVENING'
  ];

  budgetOptions = [
    'low',
    'medium',
    'high'
  ];

  productForm: FormGroup = this.fb.group({
    application_time: [''],
    category_id: [''],
    description: [''],
    ingredients: [''],
    name: [''],
    budget: [this.budgetOptions[0]],
    image: [''],
  });


  taglist = [
    'Non-Comodegenic',
    'Sls-free',
    'Paraben-free',
    'Fragrance-free',
    'Alcohol-free',
    'Eco friendly',
    'Not Animal-tested'
  ];

  constructor(
    private location: Location,
  ) {
  }

  ngOnInit() {
    this.productsService.fetchCategories().subscribe((data: any) => {
      this.categories = data;
    });
  }

  goBack() {
    this.location.back();
  }

  save() {
    const product: Product = {
      ...this.productForm.value,
    };

    const formData = new FormData();

    formData.append('name', product.name);
    formData.append('description', product.description);
    formData.append('category_id', this.productForm.controls['category_id'].value);
    formData.append('usage_instructions', product.usage_instructions);
    formData.append('application_time', JSON.stringify(this.productForm.controls['application_time'].value));
    // formData.append('application_time', JSON.stringify(this.productForm.controls['application_time'].value));
    formData.append('ingredients', JSON.stringify(this.productForm.controls['ingredients'].value));
    formData.append('image', this.productForm.controls['image'].value);
    formData.append('budget', this.productForm.controls['budget'].value);


    console.log(formData);

    this.productsService.createNewProduct(formData)
      .subscribe({
        next: () => {
          this.productsService.fetchProducts().subscribe({
            next: (products) => {
              this.productsService.updateProductsList(products);
            }
          });
          this.goBack();
        },
        error: (error) => {
          this._snackBar.open('Error saving product', 'Close');
        }
      });
  }

  remove(topping: string) {
    const toppings = this.productForm.controls['ingredients'].value ?? [];

    this.removeFirst(toppings, topping);
    this.productForm.controls['ingredients'].setValue(toppings); // To trigger change detection
  }

  removeAppTime(appTime: string) {
    const appTimes = this.productForm.controls['application_time'].value ?? [];

    this.removeFirst(appTimes, appTime);
    this.productForm.controls['application_time'].setValue(appTimes); // To trigger change detection
  }

  onFileSelected(file: File) {
    this.productForm.patchValue({image: file});
    console.log(file);
    console.log(this.productForm.value);
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);

    if (index !== -1) {
      array.splice(index, 1);
    }
  }
}
